import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import CustomHeader from '../components/Header'
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import Select from 'react-select'
import GroupVRNSelect from '../containers/comps/GroupVRNSelectContainer'
import AdvanceTableWithDeleteButton from '../components/Tables/AdvanceTableWithDeleteButton';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from "../config/axiosConfig";

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: '#7367f0'

    })
}

const firstDate = new Date();
const currentDate = new Date();

class MaintenanceLog extends React.Component {
    constructor(props) {
        super(props);
         
        this.state = {
            startDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10),
            endDate: new Date().toISOString().substring(0, 10),
            selectedVRN:'',
            vrnId:'0',
            groupid:'',
            groups: [],
            vrnOptions: [],      
            VRNMappingID:0,
            vehiclesOptions: [
                { value: '0', label: 'All Vehicles' },
                { value: '1', label: 'Vehicle(s)' },
                { value: '2', label: 'Vehicles by Group(s)' }
            ],
            entriesOptions: [
                { value: '0', label: '25' },
                { value: '1', label: '50' },
                { value: '2', label: '100' }
            ],
            Activitydata: [],
            Activitycolumns: [
                { "HeaderText": "Vehicle", "MappingColomn": "vrn" },
                { "HeaderText": "Activity", "MappingColomn": "maintenanceActivity" },
                { "HeaderText": "Activity Carried Out On", "MappingColomn": "reminderDate" },
                { "HeaderText": "Comments", "MappingColomn": "comments" },
                
            ],

            Option: 1,
            Group: 0,
            Vehicle: 0,
            DeletedRecordId:0,
        }
        this.changeHandler = this.changeHandler.bind(this)
        this.submitHandler = this.submitHandler.bind(this)

        this.optionChange = this.optionChange.bind(this)
        this.groupChange = this.groupChange.bind(this)
        this.vehicleChange = this.vehicleChange.bind(this)
        this.bindGrid=this.bindGrid.bind(this)
        this.GetDeleteSelectedRecords=this.GetDeleteSelectedRecords.bind(this)
    }

    componentDidMount() {
        const data = {
            UserBranchID: this.props.data.selectedBranchId,
        }
        axiosConfig.post('Portal/GetVRNGroupMapping', data)
            .then(res => {
                for (var i = 0; i < res.data.groupVRN.length; i++) {
                    this.setState(prevState => ({
                        groups: [...prevState.groups, { value: res.data.groupVRN[i].groupID, label: res.data.groupVRN[i].groupName, vrn: res.data.groupVRN[i].vrnModel }]
                    }))
                }
            }
            )
            .catch(function (error) {
            }
            );

        
    }

    async changeGroup(selectedOption) {
        var tmpArray = []
        
       await this.setState({groupid:selectedOption.value});
         
        this.setState({
            vrnOptions: []
        }, function () {
             
           
            this.setState({selectedVRN:''});

            let tmpArray = this.state.groups.find(groupid => groupid.value === selectedOption.value)
            tmpArray.vrn.map((el, index) => {

                this.setState(prevState => ({
                    vrnOptions: [...prevState.vrnOptions,
                    {
                        value: el.mappingID,
                        label: el.vrn
                    }]
                }))

            })
        });
    }

    changeHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
      }
       
    
      async submitHandler(e){
        this.bindGrid();
      }

    async bindGrid(){

        let token=localStorage.getItem('token');

        let cards = []

        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post("Portal/GetVehicleHealthActivityByVRN",
                {
                    UserAccountBranchId: this.props.data.selectedBranchId,
                    SearchTypeID:this.state.Option,
                    VRNMappingID:this.state.Vehicle,
                    VRNGroupingID:this.state.Group,
                    startDate:this.state.startDate,
                    endDate:this.state.endDate,
                }
            )
            .then(Response => {
                  this.setState({
                    Activitydata:Response.data.lstActivityDetail
                  });
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
    }


    async VRNOnChange(selectedOption){
        await this.setState({vrnId:selectedOption.value});
        await this.setState({selectedVRN:selectedOption.label});
        
         
     }

    async optionChange(selectedOption) {
        if (selectedOption == 1) {
            await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
            this.bindGrid();
        }
        else
            await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
    }

    async vehicleChange(selectedVehicle) {
        await this.setState({ Vehicle: selectedVehicle, Group: 0 })
        this.bindGrid()
    }

    async groupChange(selectedGroup) {
        await this.setState({ Group: selectedGroup, Vehicle: 0 })
    }
    GetDeleteSelectedRecords = (childData) => {

        debugger;

        this.setState({ DeletedRecordId: childData.vehicleHealthId })

        const data = {
            VehicleHelathId: this.state.DeletedRecordId,
            UserId: this.state.UserBranchID
        }
        axiosConfig.post("Portal/GetDeleteMaintenanceLog",data)
            .then(res => {
                 this.bindGrid();
              Swal.fire(
                'Deleted!',
                'Record has been deleted.',
                'success'
              )
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
      }


    render() {

       const {   startDate, endDate} = this.state;
        return (
            <>
                  <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Maintenance Log</h4>
                                </div>
                                <div className="card-content">
                                    <div className="card-body"></div>
                                    <div>
                                     
                                    </div><br />
                                        <div className="form-body">
                                            
                                            <div>
                                                <Container>
                                                    <Row>
                                                        <GroupVRNSelect
                                                                showVehiclesInDropDown='yes'                                                                
                                                                onOptionChange={this.optionChange}
                                                                onGroupChange={this.groupChange}
                                                                onVehicleChange={this.vehicleChange}
                                                            ></GroupVRNSelect>
                                                    </Row>
                                                </Container>
                                            </div>
                                          <br />
                                            <div className="row">

                                            {/* 
                                            
                                            <div className="col-md-6 col-12">
                                                <div className="form-group">
                                                <p className="text-left">Please Select Vehicle Group</p>
                                                <Select
                                                     options={this.state.groups}
                                                    styles={customStyles}
                                                    onChange={this.changeGroup}
                                                    
                                                    ></Select>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group">
                                                <p className="text-left">Please Select Vehicle</p>
                                                <Select
                                                        options={this.state.vrnOptions}
                                                        styles={customStyles}
                                                        onChange={this.VRNOnChange}
                                                        
                                                    
                                                    ></Select>
                                                </div>
                                            </div>
                                          */}
                                           
                                           
                                            <div className="col-md-6 col-12">
                                                <div className="form-label-group">
                                                    <input type="date" id="startDate" name="startDate" value={this.state.startDate} onChange={this.changeHandler} className="form-control" />
                                                    <label htmlFor="country-floating">Choose Start Time</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-label-group">
                                                    <input type="date"  id="endDate" name="endDate" value={this.state.endDate} onChange={this.changeHandler} className="form-control" />
                                                    <label htmlFor="country-floating">Choose End Time</label>
                                                </div>
                                            </div>
                                            
                                             <div className="col-12 " style={{ textAlign: 'center' }}>
                                                    <button type="submit" className="btn btn-shell mr-1 mb-1" onClick={this.submitHandler} >Generate Report</button>
                                                </div>
                                              
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 col-12">
                                                 
                                                    <AdvanceTableWithDeleteButton parentDeletedObjectCallback={this.GetDeleteSelectedRecords} data={this.state.Activitydata} columns={this.state.Activitycolumns}>
                                                    </AdvanceTableWithDeleteButton>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                </>
        );
    }
}

export default MaintenanceLog;









